import { render } from "./Hello.vue?vue&type=template&id=72951502&scoped=true"
import script from "./Hello.vue?vue&type=script&lang=js"
export * from "./Hello.vue?vue&type=script&lang=js"

import "./Hello.vue?vue&type=style&index=0&id=72951502&scoped=true&lang=css"

import exportComponent from "/Users/Learning/Resource/workspace/vscode/HTML/jiang/anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72951502"]])

export default __exports__